/**
 * @module app.bdc.reports.sepaSeddifCtrl
 */
define(['angular', 'moment'], function(angular, moment) {


    function SepaSeddifCtrl($scope, $window, $rootScope) {
        var self = {};
        self.client = $rootScope.order.client;

        self.IBAN = self.client.IBAN && self.client.IBAN !== '' ? self.client.IBAN.split('') : [];
        self.codeBic = self.client.codeBic && self.client.codeBic !== '' ? self.client.codeBic.split('') : [];

        /**
         * Get the date of the day
         * @return {String}
         */
        self.getDate = function getDate() {
            return moment().format('DD/MM/YYYY');
        };

        return self;
    }

    SepaSeddifCtrl.$inject = ['$scope', '$window', '$rootScope'];

    angular.module('app.bdc.reports.sepaSeddifCtrl', []).controller('SepaSeddifCtrl', SepaSeddifCtrl);
});
